import { useMsal } from '@azure/msal-react';
import { Fragment, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import * as reportApi from '../api/PomReport';
import { IPomReportAreaData, IPomReportCategoryData, IPomReportCategorySumItem, IPomReportDataCategory, IPomReportDataInfo, IPomReportDataSubCategory, IPomReportDataSubCategoryDetails, IPomReportResultCategoryData, IPomReportResultData, IPomReportResultSubData, IPomReportSubCategoryData, IPomReportTotalSumItem, IUserProfile, REPORTSTATUS } from '../util/DataModelInterface'
import { Spinner } from '../components/Spinner';
import { ToastWrap } from '../components/ToastWrap';
import { statusView } from '../components/CommonControls';
import { useLocation } from 'react-router-dom';
import * as storage from '../util/StorageUtil';
import parse from 'html-react-parser';
import { PomList } from '../components/PomList';
import useToastHandler from '../hooks/useToastHandler';
import { formatFinCurrency, formatFinNumber, getDeadline } from '../util/FormatDateUtil';

// import { Button } from "react-bootstrap";

export const Report = () => {
    const { instance } = useMsal();
    const intl = useIntl();
    const lang = intl.locale;
    const { state } = useLocation();
    const { addToast } = useToastHandler();

    const [user, setUser] = useState({} as IUserProfile);
    const [categories, setCategories] = useState([] as IPomReportCategoryData[]);
    const [reportData, setReportData] = useState({} as IPomReportDataCategory);
    const [reportInfoData, setReportInfoData] = useState({} as IPomReportDataInfo);
    const [reportCatSumData, setReportCatSumData] = useState({} as {[x: string]: IPomReportCategorySumItem});
    const [reportTotSumData, setReportTotSumData] = useState({} as IPomReportTotalSumItem);
    const [open, setOpen] = useState({} as {[x: number]: boolean});
    const [isAllOpen, setIsAllOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [toastActive, setToastActive] = useState(false);
    const [toastHeader, setToastHeader] = useState("");
    const [toastText, setToastText] = useState("");
    const [toastType, setToastType] = useState("");
    const [reporter, setReporter] = useState("");
    const [reference, setReference] = useState("");
    const [reportStatus, setReportStatus] = useState(state.status);
    const [editingReport, setEditingReport] = useState(false);
    const [confirmingPage, setConfirmingPage] = useState(state.confirm);
    const [categoriesWithData, setCategoriesWithData] = useState([]);
    const [period, ] = useState(state.period);
    const [companyId, ] = useState(state.companyId);
    const [companyName, ] = useState(state.companyName);
    const [errorText, setErrorText] = useState("");
    const [showTip, setShowTip] = useState([""]);
    const [tipCategory, setTipCategory] = useState("");

    const year = period.split("-")[0];
    const month = period.split("-")[1];
    const timePeriod = month + "/" + year;

    useEffect(() => {
        let activeAccount = instance.getActiveAccount();
        if(activeAccount) {
            const userData = storage.getUser();
            // console.log("Report - user: ", userData);
            setUser(userData ? userData : {} as IUserProfile);
          }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    // console.log("lang:", lang);
    let tableheadings=['pricegroup', 'price', 'fin', 'aland', 'b2b', 'sum'];

    useEffect(() => {
        setErrorText("");

        const fetchDataAsync = async () => {
            try {
                setLoading(true);
                const data1 = await reportApi.getReport(companyId, period);
                // console.log("Pom repor[t" + period + "] - data: " + JSON.stringify(data1));
                if (data1?.result) {
                    setReportData(data1.result.categories);
                    setReportInfoData(data1.result.info);
                    setReporter(data1.result.info?.name ? data1.result.info.name : "")
                    setReference(data1.result.info?.reference ? data1.result.info.reference : "");
                    setReportStatus(data1.result.info ? data1.result.info.status : "Missing");
                }
                else if (data1?.error) {
                    addToast(data1.error, 'reports', 'fetch');
                    setErrorText(data1.error.value);
                }
                setToastActive(false);
                setEditingReport(false);

                const data2 = await reportApi.getCategories();
                // console.log("Pom categories - data", data2);
                if (data2?.error) {
                    addToast(data2.error, 'reports', 'fetch');
                    setErrorText(data2.error.value);
                } else if (data2) {
                    setCategories(data2);
                    calculateCatSums(data1.result.info, data1.result.categories, data2);
                    if (data2.length > 0) {
                        let openDetails = {} as {[x: number]: boolean};
                        data2.forEach( (cat: IPomReportCategoryData, catIndex: number) => {
                            openDetails[catIndex] = false;
                        });
                        setOpen(openDetails);
                    }
                }
                // calculateCatSums(data1.result.info, data1.result.categories, sortedCat);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                return error;
            }
          }
        fetchDataAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId, period]);

    useEffect(() => {
        const isDetailsOpen = Object
            .values(open)
            .every(val => val);
        setIsAllOpen(isDetailsOpen);
    }, [open]);

    const toggleOneDetailSections = (catIndex: number, e: any) => {
        if (open[catIndex] !== e.target.open) {
            setOpen({...open, [catIndex]: e.target.open});
        }
    }

    const toggleDetailsSections = (action: string) => {
        let openValue = (action === "expand") ? true : false;
        let openDetails = {...open} as any;
        Object.keys(open).forEach(o => openDetails[o] = openValue);
        setOpen(openDetails);
    }

    const calculateRowSum = (subData: any, price: string, isNum?: boolean) => {
        let fin = typeof subData.amount_fin !== 'number' ? 0 : parseFloat(subData.amount_fin);
        let al = typeof subData.amount_aland !== 'number' ? 0 : parseFloat(subData.amount_aland);
        let b2b = typeof subData.amount_b2b !== 'number' ? 0 : parseFloat(subData.amount_b2b);
        let sumVal = fin + al + b2b;
        let sumEur = parseFloat(price) * sumVal;
        let result;
        if (!isNum) {
            result = formatFinCurrency(sumEur);
        } else {
            result = sumEur;
        }
        return result;
    }

    const calculateCatSums = (infoData: IPomReportDataInfo, categoriesData: { [x: string]: any; }, categories: IPomReportCategoryData[]) => {
        // console.log("- calculateCatSums -");
        let categoriesWithData = [] as any;
        let catSums = {} as {[x: string]: IPomReportCategorySumItem};
        let totalSum = {} as IPomReportTotalSumItem;
        let total_fin_eur = 0;
        let total_fin_kg = 0;
        let total_fin_pcs = 0;
        let total_aland_eur = 0;
        let total_aland_kg = 0;
        let total_aland_pcs = 0;
        let total_b2b_eur = 0;
        let total_b2b_kg = 0;
        let total_b2b_pcs = 0;

        Object.keys(categoriesData).forEach((categoryKey) => {
            const catData = categoriesData[categoryKey];
            let cat = categories.find((category: any) => category["code"] === categoryKey);
            let catSumItem = {} as IPomReportCategorySumItem;
            let catSumFinEur = 0;
            let catSumAlEur = 0;
            let catSumB2bEur = 0;
            let catSumFinKg = 0;
            let catSumAlKg = 0;
            let catSumB2bKg = 0;
            let catSumFinPcs = 0;
            let catSumAlPcs = 0;
            let catSumB2bPcs = 0;
            let catSumTotalEur = 0;
            let catSumTotalKg = 0;
            let catSumTotalPcs = 0;

            catData.forEach((subData: any) => {
                let subCode = Object.keys(subData)[0];
                let subCat = cat?.subs.find((sub: any) => sub["code"] === subCode);
                let unit = subCat ? subCat.unit : "kg";
                catSumFinEur += parseFloat(subData[subCode].eur_fin);
                catSumAlEur += parseFloat(subData[subCode].eur_aland);
                catSumB2bEur += parseFloat(subData[subCode].eur_b2b);
                if (unit === "kg") {
                    catSumFinKg += (subData[subCode].amount_fin ? parseFloat(subData[subCode].amount_fin) : 0);
                    catSumAlKg += (subData[subCode].amount_aland ? parseFloat(subData[subCode].amount_aland) : 0);
                    catSumB2bKg += (subData[subCode].amount_b2b ? parseFloat(subData[subCode].amount_b2b) : 0);
                } else {
                    catSumFinPcs += (subData[subCode].amount_fin ? parseFloat(subData[subCode].amount_fin) : 0);
                    catSumAlPcs += (subData[subCode].amount_aland ? parseFloat(subData[subCode].amount_aland) : 0);
                    catSumB2bPcs += (subData[subCode].amount_b2b ? parseFloat(subData[subCode].amount_b2b) : 0);
                }
            })
            catSumTotalEur += (catSumFinEur + catSumAlEur + catSumB2bEur);
            catSumTotalKg += (catSumFinKg + catSumAlKg + catSumB2bKg);
            catSumTotalPcs += (catSumFinPcs + catSumAlPcs + catSumB2bPcs);
            catSumItem = {
                "report_id": infoData.report_id,
                "category": categoryKey,
                "total_aland_eur": catSumAlEur,
                "total_aland_kg": catSumAlKg,
                "total_aland_pcs": catSumAlPcs,
                "total_b2b_eur": catSumB2bEur,
                "total_b2b_kg": catSumB2bKg,
                "total_b2b_pcs": catSumB2bPcs,
                "total_fin_eur": catSumFinEur,
                "total_fin_kg": catSumFinKg,
                "total_fin_pcs": catSumFinPcs,
                "total_eur": catSumTotalEur,
                "total_kg": catSumTotalKg,
                "total_pcs": catSumTotalPcs
            }
            total_fin_eur += catSumFinEur;
            total_fin_kg += catSumFinKg;
            total_fin_pcs += catSumFinPcs;
            total_aland_eur += catSumAlEur;
            total_aland_kg += catSumAlKg;
            total_aland_pcs += catSumAlPcs;
            total_b2b_eur += catSumB2bEur;
            total_b2b_kg += catSumB2bKg;
            total_b2b_pcs += catSumB2bPcs;

            catSums[categoryKey] = catSumItem;
            // console.log("catSumItem", catSumItem);
            // console.log("- calculateCatSums -" + categoryKey +  " total_eur: " + catSumTotalEur + " kg: " + catSumTotalKg);

            // If there is data in this category, mark it for confirming phase
            if (catSumTotalKg > 0 || catSumTotalPcs > 0) {
                categoriesWithData.push(categoryKey);
            }
        });
        totalSum.report_id = infoData.report_id;
        totalSum.total_fin_eur = total_fin_eur;
        totalSum.total_fin_kg = total_fin_kg;
        totalSum.total_fin_pcs = total_fin_pcs;
        totalSum.total_aland_eur = total_aland_eur;
        totalSum.total_aland_kg = total_aland_kg;
        totalSum.total_aland_pcs = total_aland_pcs;
        totalSum.total_b2b_eur = total_b2b_eur;
        totalSum.total_b2b_kg = total_b2b_kg;
        totalSum.total_b2b_pcs = total_b2b_pcs;
        totalSum.total_eur = total_fin_eur + total_aland_eur + total_b2b_eur;
        totalSum.total_kg = total_fin_kg + total_aland_kg + total_b2b_kg;
        totalSum.total_pcs = total_fin_pcs + total_aland_pcs + total_b2b_pcs;

        // console.log("- calculateCatSums -", catSums);
        setReportCatSumData(catSums);
        setReportTotSumData(totalSum);
        setCategoriesWithData(categoriesWithData);
    }

    const calculateGroupSum = (cat: IPomReportCategoryData) => {
        // console.log("calculateGroupSum code", cat.code);
        let catSum = 0;
        const subs = cat.subs;
        let catReportData = reportData[cat.code] as any;
        subs.forEach((sub: IPomReportSubCategoryData) => {
            let subcategory = sub.code;
            let subData = {} as any;
            if (catReportData && Array.isArray(catReportData)) {
                let subCat = catReportData.find((subItem) => subItem[subcategory]);
                subData = subCat ? subCat[subcategory] : undefined;
                if (subData) {
                    catSum += (parseFloat(subData.eur_fin) + parseFloat(subData.eur_aland) + parseFloat(subData.eur_b2b));
                }
            }
        });
        let sum = formatFinCurrency(catSum);
        return sum;
    }

    const handleReference = (e: { target: { value: any; name: string; }; }) => {
        let value = e.target.value;
        // console.log("handleReference - value", value);

        setReference(value);
        setEditingReport(true);
    }

    const updateReportValue = (code: string, subcategory: string, area: string, value: any) => {

        // This is needed to show what user has typed, so no modifying yet!
        let newReportData = {...reportData} as any;
        if (!newReportData[code]) {
            newReportData[code] = [] as IPomReportDataSubCategory[];
        }
        let index = newReportData[code].findIndex((sub: { [x: string]: any; }) => sub[subcategory]);
        if (index < 0) {
            let subCat = {} as IPomReportDataSubCategory;
            let subDetails = {
                // "amount_fin": 0,
                // "amount_aland": 0,
                // "amount_b2b": 0,
                "eur_fin": 0,
                "eur_aland": 0,
                "eur_b2b": 0
            } as IPomReportDataSubCategoryDetails;
            subCat[subcategory] = subDetails;
            newReportData[code].push(subCat);
            index = newReportData[code].findIndex((sub: { [x: string]: any; }) => sub[subcategory]);
        }
        let area_amount = "amount_" + area;
        let areaMod = "modified_" + area;
        newReportData[code][index][subcategory][area_amount] = value;
        newReportData[code][index][subcategory][areaMod] = 1; // Field is modified -> make it red!
        setReportData(newReportData);
    }

    const getCorrectPrice = (priceObj: any) => {
        let parsedMonth = parseInt(month) < 10 ? '0' + parseInt(month) : parseInt(month);
        let reportPeriodDate = new Date(`${year}-${parsedMonth}-10`);
        let priceList = Object.keys(priceObj).sort().reverse();

        let foundPrice = priceList.find((yyyymm) => {
            let priceDate = new Date(`${yyyymm}-9`);
            return reportPeriodDate > priceDate;
        })
        if (foundPrice) {
            return priceObj[foundPrice];
        }
        else {
            console.error("Price not found!");
            // Return latest!
            return priceObj[priceList[0]];
        }
    }

    const updatePriceAndValue = (code: string, subcategory: string, area: string, value: any) => {

        // Typing done -> modify value to number now... (remove other character also)
        let modValue = parseFloat(value.replace(/[^0-9,.]/g, '').replace(',', '.'));
        if(isNaN(modValue)) modValue = 0;
        // console.log('updatePriceAndValue - modValue %s', modValue);

        let newReportData = {...reportData} as any;
        let index = newReportData[code].findIndex((sub: { [x: string]: any; }) => sub[subcategory]);
        let area_amount = "amount_" + area;
        let areaMod = "modified_" + area;
        newReportData[code][index][subcategory][area_amount] = modValue;
        newReportData[code][index][subcategory][areaMod] = 1; // Field is modified -> make it red!

        let cat = categories.find((category: any) => category["code"] === code);
        let subCat = cat?.subs.find((subCategory: any) => subCategory["code"] === subcategory);
        let price = subCat?.price ? getCorrectPrice(subCat.price) : "0";

        let area_value = "eur_" + area;
        let calculatedPrice = parseFloat(price) * modValue;
        newReportData[code][index][subcategory][area_value] = calculatedPrice;

        // let subCatData = newReportData[code][index][subcategory];
        // let rowSum = calculateRowSum(subCatData, price);
        // console.log("rowSum", rowSum);

        setReportData(newReportData);

        // To get red dot to category
        let newCategories = [...categories] as IPomReportCategoryData[];
        let catIndex = newCategories.findIndex((cat) => cat.code === code);
        newCategories[catIndex].mod = true;
        setCategories(newCategories);

        setEditingReport(true);
    }

    const decodeName = (eventName: string) => {
        let nameList = eventName.split("_");
        let code = nameList[0];
        let subcategory = nameList[1];
        let area = nameList[2];
        return {code, subcategory, area};
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter' && !isReportReadonly()) {
            // console.log('handleEnter - value %s name %s', e.target.value, e.target.name);
            let {code, subcategory, area} = decodeName(e.target.name);

            updatePriceAndValue(code, subcategory, area, e.target.value);
            calculateCatSums(reportInfoData, reportData, categories);
        }
      }

    const handleBlur = (e: { target: { value: any; name: string; }; }) => {
        // console.log('handleBlur - value %s name %s', e.target.value, e.target.name);
        if (/*e.target.value &&*/ !isReportReadonly()) {
            let {code, subcategory, area} = decodeName(e.target.name);

            updatePriceAndValue(code, subcategory, area, e.target.value);
            calculateCatSums(reportInfoData, reportData, categories);
        }
      }

    const handleChange = (e: { target: { value: any; name: string; }; }) => {
        let value = e.target.value;
        // console.log('handleChange - value %s name %s', value, e.target.name);
        let {code, subcategory, area} = decodeName(e.target.name);

        updateReportValue(code, subcategory, area, value);
    }

    const checkModifiedFields = () => {

        let newReportData = {...reportData};
        Object.keys(newReportData).forEach((categoryKey) => {
            let catData = newReportData[categoryKey];
            catData.forEach( (subData) => {
                let subCode = Object.keys(subData)[0];
                if (subData[subCode]["modified_fin"] === 1)
                    subData[subCode]["modified_fin"] = 2;
                if (subData[subCode]["modified_aland"] === 1)
                    subData[subCode]["modified_aland"] = 2;
                if (subData[subCode]["modified_b2b"] === 1)
                    subData[subCode]["modified_b2b"] = 2;
            })
        });
        setReportData(newReportData);

        // Remove red dot from category
        let newCategories = [...categories] as IPomReportCategoryData[];
        newCategories.forEach((cat) => cat.mod = false);
        setCategories(newCategories);
    }

    const clearModifiedFields = () => {
        let newReportData = {...reportData};
        Object.keys(newReportData).forEach((categoryKey) => {
            let catData = newReportData[categoryKey];
            catData.forEach( (subData) => {
                let subCode = Object.keys(subData)[0];
                    subData[subCode]["modified_fin"] = 0;
                    subData[subCode]["modified_aland"] = 0;
                    subData[subCode]["modified_b2b"] = 0;
            })
        });
        setReportData(newReportData);
    }

    const saveReport = async () => {
        setLoading(true);
        setReportStatus((reportStatus === REPORTSTATUS.NEW || reportStatus === REPORTSTATUS.ONGOING) ? REPORTSTATUS.ONGOING : REPORTSTATUS.REOPENED);
        setReporter(user.name);
        let result = {} as IPomReportResultData;
        result["info"] = {
            "user_name": user.user_name,
            "company_id": reportInfoData.company,
            "reference": reference,
            "status": (reportStatus === REPORTSTATUS.NEW || reportStatus === REPORTSTATUS.ONGOING) ? REPORTSTATUS.ONGOING : REPORTSTATUS.REOPENED
        };
        result["inputs"] = [];
        Object.keys(reportData).forEach((categoryKey) => {
            const catData = reportData[categoryKey];
            // console.log("catData", catData);
            let cat = {} as IPomReportResultCategoryData;
            cat.code = categoryKey;
            cat.subs = catData.map( (subData: any) => {
                // console.log("subData", subData);
                let subCode = Object.keys(subData)[0];
                let item = {} as IPomReportResultSubData;
                item.code = subCode;
                let areaItem: IPomReportAreaData = {
                    "fi": {
                        "value": parseFloat(subData[subCode]["eur_fin"]) || 0,
                        "weight": parseFloat(subData[subCode]["amount_fin"]) || 0
                    },
                    "al": {
                        "value": parseFloat(subData[subCode]["eur_aland"]) || 0,
                        "weight": parseFloat(subData[subCode]["amount_aland"]) || 0
                    },
                    "b2b": {
                        "value": parseFloat(subData[subCode]["eur_b2b"]) || 0,
                        "weight": parseFloat(subData[subCode]["amount_b2b"]) || 0
                    }
                };
                item.inputs = areaItem;
                return item;
            });
            cat.catSums = reportCatSumData[categoryKey];
            result["inputs"].push(cat);
        });
        result["totals"] = reportTotSumData;
        // console.log("result", result);

        await reportApi.postReport(period, result).then((data: any) => {
            // console.log("postReport [" + period + "] - response: " + JSON.stringify(data));
            if (data?.error) {
                addToast(data.error, 'reports', 'save');
            } else {
                checkModifiedFields();
                setEditingReport(false);
                setToastHeader(intl.formatMessage({id: 'report.saved'}));
                setToastText(user.name + " " + intl.formatMessage({id: 'report.saved.info'}));
                setToastType('success');
                setToastActive(true);
            }
          }).finally(() => {
            setLoading(false);
          });
    }

    const startConfirmReport = async () => {
        // Save first if still editing phase ongoing...
        if (editingReport) {
            await saveReport();
        }
        setConfirmingPage(true);
    }

    const confirmReport = () => {
        setLoading(true);
        let newStatus = (reportStatus === REPORTSTATUS.NEW || reportStatus === REPORTSTATUS.ONGOING) ? REPORTSTATUS.CONFIRMED : REPORTSTATUS.CORRECTED;
        reportApi.setReportStatus(reportInfoData.report_id, newStatus, user.user_name).then((data: any) => {
            //console.log("setReportStatus [" + reportInfoData.report_id + "] - response: " + JSON.stringify(data));
            if (data?.error) {
                addToast(data.error, 'reports', 'confirm');
            } else {
                setReportStatus(newStatus);
                setReporter(user.name);
                clearModifiedFields();
                setConfirmingPage(false);
                setToastHeader(intl.formatMessage({id: 'report.confirmed'}));
                setToastText(user.name + " " + intl.formatMessage({id: 'report.confirmed.info'}));
                setToastType('success');
                setToastActive(true);
            }
          }).finally(() => {
            setLoading(false);
          });
    }

    const startEditingReport = () => {
        setConfirmingPage(false);
        setEditingReport(true);
        setCategoriesWithData([]);
    }

    const exportReport = () => {
        let reportJsonData = [] as any;

        categories.forEach((cat: IPomReportCategoryData) => {
            let code = cat.code;
            let catData = reportData[code];
            let catSumData = reportCatSumData[code];
            cat.subs.forEach((sub: IPomReportSubCategoryData, index: number) => {
                let subcategory = sub.code;
                let subPrice = getCorrectPrice(sub.price);//sub.price;
                let subPriceMod = parseFloat(subPrice);
                // if (catData && Array.isArray(catData)) {
                    let subCat = catData?.find((subItem) => subItem[subcategory]);
                    let subData = subCat ? subCat[subcategory] : undefined;
                    // if (subData) {
                        let row = {} as any;
                        if (sub) {
                            let subName = lang === "fi-FI" ? sub.name_fi : (lang === "en-GB" ? sub.name_en : sub.name_se);
                            row[intl.formatMessage({id: 'report.header.pricegroup'})] = sub.code + " " + subName;
                            row[intl.formatMessage({id: 'report.header.price'})] = subPriceMod;

                            if (sub.unit === "kg") {
                                row[intl.formatMessage({id: 'report.header.fin.kg'})] = subData?.amount_fin ? subData.amount_fin : "";
                                row[intl.formatMessage({id: 'report.header.fin.pc'})] = "";
                                row[intl.formatMessage({id: 'report.header.aland.kg'})] = subData?.amount_aland ? subData.amount_aland : "";
                                row[intl.formatMessage({id: 'report.header.aland.pc'})] = "";
                                row[intl.formatMessage({id: 'report.header.b2b.kg'})] = subData?.amount_b2b ? subData.amount_b2b : "";
                                row[intl.formatMessage({id: 'report.header.b2b.pc'})] = "";
                            } else {
                                row[intl.formatMessage({id: 'report.header.fin.kg'})] = "";
                                row[intl.formatMessage({id: 'report.header.fin.pc'})] = subData?.amount_fin ? subData.amount_fin : "";
                                row[intl.formatMessage({id: 'report.header.aland.kg'})] = "";
                                row[intl.formatMessage({id: 'report.header.aland.pc'})] = subData?.amount_aland ? subData.amount_aland : "";
                                row[intl.formatMessage({id: 'report.header.b2b.kg'})] = "";
                                row[intl.formatMessage({id: 'report.header.b2b.pc'})] = subData?.amount_b2b ? subData.amount_b2b : "";
                            }
                            // row[intl.formatMessage({id: 'report.header.fin'})] = subData?.amount_fin ? subData.amount_fin : 0;
                            // row[intl.formatMessage({id: 'report.header.aland'})] = subData?.amount_aland ? subData.amount_aland : 0;
                            // row[intl.formatMessage({id: 'report.header.b2b'})] = subData?.amount_b2b ? subData.amount_b2b : 0;
                            row[intl.formatMessage({id: 'report.header.sum'})] = subData ? calculateRowSum(subData, subPrice, true) : 0;
                            reportJsonData.push(row);
                        }
                    // }
                // }
            });
            // catSumData
            let row = {} as any;
            let totalCatFee = catSumData?.total_fin_eur + catSumData?.total_aland_eur + catSumData?.total_b2b_eur;
            row[intl.formatMessage({id: 'report.header.pricegroup'})] = "";
            row[intl.formatMessage({id: 'report.header.price'})] = "";
            row[intl.formatMessage({id: 'report.header.fin.kg'})] = catSumData?.total_fin_kg ? catSumData?.total_fin_kg : "";
            row[intl.formatMessage({id: 'report.header.fin.pc'})] = catSumData?.total_fin_pcs ? catSumData?.total_fin_pcs : "";
            row[intl.formatMessage({id: 'report.header.aland.kg'})] = catSumData?.total_aland_kg ? catSumData?.total_aland_kg :"";
            row[intl.formatMessage({id: 'report.header.aland.pc'})] = catSumData?.total_aland_pcs ? catSumData?.total_aland_pcs : "";
            row[intl.formatMessage({id: 'report.header.b2b.kg'})] = catSumData?.total_b2b_kg ? catSumData?.total_b2b_kg : "";
            row[intl.formatMessage({id: 'report.header.b2b.pc'})] = catSumData?.total_b2b_pcs ? catSumData?.total_b2b_pcs : "";
            row[intl.formatMessage({id: 'report.header.sum'})] = totalCatFee;
            reportJsonData.push(row);
        });
        // emtpy row
        let row_empty = {} as any;
        row_empty[intl.formatMessage({id: 'report.header.pricegroup'})] = "WEEE1-6";
        row_empty[intl.formatMessage({id: 'report.header.price'})] = "";
        row_empty[intl.formatMessage({id: 'report.header.fin.kg'})] = "";
        row_empty[intl.formatMessage({id: 'report.header.fin.pc'})] = "";
        row_empty[intl.formatMessage({id: 'report.header.aland.kg'})] = "";
        row_empty[intl.formatMessage({id: 'report.header.aland.pc'})] = "";
        row_empty[intl.formatMessage({id: 'report.header.b2b.kg'})] = "";
        row_empty[intl.formatMessage({id: 'report.header.b2b.pc'})] = "";
        row_empty[intl.formatMessage({id: 'report.header.sum'})] = "";
        reportJsonData.push(row_empty);

        // Total total
        let row_total = {} as any;
        let totalFee = reportTotSumData?.total_fin_eur + reportTotSumData?.total_aland_eur + reportTotSumData?.total_b2b_eur;
        row_total[intl.formatMessage({id: 'report.header.pricegroup'})] = "";
        row_total[intl.formatMessage({id: 'report.header.price'})] = "";
        row_total[intl.formatMessage({id: 'report.header.fin.kg'})] = reportTotSumData?.total_fin_kg ? reportTotSumData?.total_fin_kg : "";
        row_total[intl.formatMessage({id: 'report.header.fin.pc'})] = reportTotSumData?.total_fin_pcs ? reportTotSumData?.total_fin_pcs : "";
        row_total[intl.formatMessage({id: 'report.header.aland.kg'})] = reportTotSumData?.total_aland_kg ? reportTotSumData?.total_aland_kg :"";
        row_total[intl.formatMessage({id: 'report.header.aland.pc'})] = reportTotSumData?.total_aland_pcs ? reportTotSumData?.total_aland_pcs : "";
        row_total[intl.formatMessage({id: 'report.header.b2b.kg'})] = reportTotSumData?.total_b2b_kg ? reportTotSumData?.total_b2b_kg : "";
        row_total[intl.formatMessage({id: 'report.header.b2b.pc'})] = reportTotSumData?.total_b2b_pcs ? reportTotSumData?.total_b2b_pcs : "";
        row_total[intl.formatMessage({id: 'report.header.sum'})] = totalFee;
        reportJsonData.push(row_total);

        // console.log("reportJsonData", reportJsonData);

        reportApi.exportReport(
        { header: "Report " + period + " [" + reportStatus + "]",
          data: reportJsonData
        }).then((data: any) => {
            if (data?.error) {
              addToast(data.error, 'reports', 'fetch');
            }
          })
    }

    const isReportReadonly = () => {
        if (editingReport) {
            return false;
        } else if (confirmingPage) {
            return true;
        } else if (reportStatus === REPORTSTATUS.CLOSED || reportStatus === REPORTSTATUS.CONFIRMED || reportStatus === REPORTSTATUS.CORRECTED ||
                   reportStatus === REPORTSTATUS.BILLED || reportStatus === REPORTSTATUS.REBILLED) {
            return true;
        } else {
            return false;
        }
    }

    const getButtons = () => {
        if ( isReportReadonly() ) {
            return (
                <>
                <button type="button" className="btn btn-secondary btn-save" onClick={() => startEditingReport()}>
                    <i className="fa fa-edit me-2"></i>
                    <FormattedMessage id="button.report.edit"/>
                </button>
                <button type="button" className="btn btn-secondary btn-print" onClick={() => exportReport()}>
                    <i className="fa fa-download me-2"></i>
                    <FormattedMessage id="button.report.download"/>
                </button>
            </>
            )
        } 
        else {
            return (
                <>
                <button type="button" className="btn btn-secondary btn-save"
                    onClick={() => saveReport()} disabled={!editingReport}>
                    <i className="fa fa-save me-2"></i>
                    <FormattedMessage id="button.report.save"/>
                </button>
                <button type="button" className="btn btn-primary btn-submit" onClick={() => startConfirmReport()}>
                    <i className="fa fa-check me-2"></i>
                    <FormattedMessage id="button.report.confirm"/>
                </button>
            </>
            )
        }
    }

    const getReportRows = (cat: IPomReportCategoryData) => {
        const subs = cat.subs;
        let catReportData = reportData[cat.code] as IPomReportDataSubCategory[];
        // console.log("catReportData", catReportData);
        return subs.map( (sub: IPomReportSubCategoryData, index: number) => {
            let subcategory = sub.code;
            let subPrice = getCorrectPrice(sub.price);//sub.price;
            let subPriceText = formatFinNumber(subPrice, 3);
            let subUnit = sub.unit === "kpl" ? intl.formatMessage({id: 'unit.pieces'}) : sub.unit;
            let subName = lang === "fi-FI" ? sub.name_fi : (lang === "en-GB" ? sub.name_en : sub.name_se);
            let subDesc = lang === "fi-FI" ? sub.description_fi : (lang === "en-GB" ? sub.description_en : sub.description_se);
            let subData = {} as any;
            // console.log("subcategory", subcategory);
            let field_name_fin = cat.code + "_" + subcategory + "_fin_" + index;
            let amount_fin = "";
            let fin_class = "";
            let field_name_al = cat.code + "_" + subcategory + "_aland_" + index;
            let amount_al = "";
            let aland_class = "";
            let field_name_b2b = cat.code + "_" + subcategory + "_b2b_" + index;
            let amount_b2b = "";
            let b2b_class = "";
            if (catReportData && Array.isArray(catReportData)) {
                let subCat = catReportData.find((subItem) => subItem[subcategory]);
                subData = subCat ? subCat[subcategory] : undefined;
                // console.log("subData", subData);
                if (subData) {
                    if (subData.amount_fin === 0 || subData.amount_fin)
                        amount_fin = (typeof subData.amount_fin === 'number' && subData.amount_fin !== 0) ? formatFinNumber(subData.amount_fin) : subData.amount_fin;
                    if (subData.amount_aland === 0 || subData.amount_aland)
                        amount_al = (typeof subData.amount_aland === 'number' && subData.amount_aland !== 0) ? formatFinNumber(subData.amount_aland) : subData.amount_aland;
                    if (subData.amount_b2b === 0 || subData.amount_b2b)
                        amount_b2b = (typeof subData.amount_b2b === 'number' && subData.amount_b2b !== 0) ? formatFinNumber(subData.amount_b2b) : subData.amount_b2b;
                    fin_class = subData.modified_fin === 2 ? "fieldsaved" : (subData.modified_fin === 1 ? "fieldchanged" : "");
                    aland_class = subData.modified_aland === 2 ? "fieldsaved" : (subData.modified_aland === 1 ? "fieldchanged" : "");
                    b2b_class = subData.modified_b2b === 2 ? "fieldsaved" : (subData.modified_b2b === 1 ? "fieldchanged" : "");
                }
                if(confirmingPage && !amount_fin && !amount_al && !amount_b2b) {
                    // When confirming, do not show this subcategory if no data
                    return (null);
                }
            }
            return (
                <Fragment key={cat.code + "_" + index}>
                <tr key={index}>
                    <td>
                        <span className="column-label">{tableheadings[0]}</span>
                        <span>{sub.code} {subName}</span>
                        {subDesc && <>
                          <button type="button" className="btn btn-icon btn-primary btn-tooltip" aria-controls="tip1" aria-expanded="false"
                                  title={intl.formatMessage({ id: 'reports.subcategory.show.info' })}
                                  onClick={() => {
                                    const nextShowTip = [...showTip];
                                    showTip[index] !== "" ? nextShowTip[index] = "" : nextShowTip[index] = " visible";
                                    setTipCategory(cat.code.toString());
                                    setShowTip(nextShowTip);
                                  }}>
                            <i className="fa fa-info"></i><span className="sr-only"></span>
                          </button>
                          <div id={"tip"+index} className={"tip" + (tipCategory === cat.code.toString() ? showTip[index] : '')} >{subDesc}</div>
                        </>}
                    </td>
                    <td>
                        <span className="column-label">{tableheadings[1]}</span>
                        <span>{subPriceText} €/{subUnit}</span>
                    </td>
                    <td>
                        <span className="column-label">{tableheadings[2]}</span>
                        <span>
                            <div className="form-group">
                                <label htmlFor={field_name_fin} className="sr-only">{tableheadings[2]}</label>
                                { sub.fin &&
                                    <div className="input-group">
                                        <input name={field_name_fin} id={field_name_fin} className={"form-control amount " + fin_class}
                                        type="text" value={amount_fin}
                                        autoComplete="off"
                                        onKeyDown={handleKeyDown}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        readOnly={isReportReadonly()} placeholder="0,00" />
                                        <div className="input-group-append">
                                            <span className="input-group-text">{subUnit}</span>
                                        </div>
                                    </div>
                                }
                                <div aria-atomic="true" aria-live="polite">
                                    <div className="field-error">
                                        <i className="fa fa-warning me-2"></i>
                                        <FormattedMessage id="reports.obligatory.info"/>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </td>
                    <td>
                        <span className="column-label">{tableheadings[3]}</span>
                        <span>
                            <div className="form-group">
                                <label htmlFor={field_name_al} className="sr-only">{tableheadings[3]}</label>
                                { sub.aland &&
                                    <div className="input-group">
                                        <input name={field_name_al} id={field_name_al} className={"form-control amount " + aland_class}
                                        type="text" value={amount_al}
                                        autoComplete="off"
                                        onKeyDown={handleKeyDown}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        readOnly={isReportReadonly()} placeholder="0,00" />
                                        <div className="input-group-append">
                                            <span className="input-group-text">{subUnit}</span>
                                        </div>
                                    </div>
                                }
                                <div aria-atomic="true" aria-live="polite">
                                    <div className="field-error">
                                        <i className="fa fa-warning me-2"></i>
                                        <FormattedMessage id="reports.obligatory.info"/>  
                                    </div>
                                </div>
                            </div>
                        </span>
                    </td>
                    <td>
                        <span className="column-label">{tableheadings[4]}</span>
                        <span>
                            <div className="form-group">
                                <label htmlFor={field_name_b2b} className="sr-only">{tableheadings[4]}</label>
                                { sub.b2b &&
                                    <div className="input-group">
                                        <input name={field_name_b2b} id={field_name_b2b} className={"form-control amount " + b2b_class}
                                        type="text" value={amount_b2b}
                                        autoComplete="off"
                                        onKeyDown={handleKeyDown}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        readOnly={isReportReadonly()} placeholder="0,00" />
                                        <div className="input-group-append">
                                            <span className="input-group-text">{subUnit}</span>
                                        </div>
                                    </div>
                                }
                                <div aria-atomic="true" aria-live="polite">
                                    <div className="field-error">
                                        <i className="fa fa-warning me-2"></i>
                                        <FormattedMessage id="reports.obligatory.info"/>  
                                    </div>
                                </div>
                            </div>
                        </span>
                    </td>
                    <td>
                        <span className="column-label">{tableheadings[5]}</span>
                        <span><span className="rowtotal">{subData && calculateRowSum(subData, subPrice)}</span></span>
                    </td>
                </tr>
                </Fragment>
            );
        })
    }

    const getReportCategory = (cat: IPomReportCategoryData, catIndex: number) => {
        let tempCategoriesWithData = categoriesWithData as any;
        // console.log("tempCategoriesWithData", tempCategoriesWithData);
        if(confirmingPage && !tempCategoriesWithData.includes(cat.code)) {
            // When confirming, do not show this category if no data
            return (null);
        }
        let title = lang === "fi-FI" ? parse(cat.name_fi) : (lang === "en-GB" ? parse(cat.name_en) : parse(cat.name_se));
        return (
            <Fragment key={catIndex}>
            <details open={open[catIndex]} onToggle={(event) => toggleOneDetailSections(catIndex, event)}>
                <summary className={ cat.mod ? " changed" : "" }>
                <h2>
                    {cat.view_code} {title}
                </h2>
                </summary>
                <div id={cat.code}>
                    <div className="table-responsive ">
                    <table className="table table-striped table-hover border-bottom ">
                        <caption className="sr-only">
                            {cat.view_code} {title}
                        </caption>
                        <thead>
                            <tr>
                                {tableheadings.map( (headerText: string, index:number) => (
                                    <th key={index}>
                                        <FormattedMessage id={`report.header.${headerText}`}/>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            { getReportRows(cat) }
                        </tbody>
                        <tfoot role="row">
                            <tr className="total">
                                <td><span className="column-label">{tableheadings[0]}</span>
                                    <FormattedMessage id="report.details.sum"/>
                                </td>
                                <td><span className="column-label">{tableheadings[1]}</span></td>
                                <td><span className="column-label">{tableheadings[2]}</span></td>
                                <td><span className="column-label">{tableheadings[3]}</span></td>
                                <td><span className="column-label">{tableheadings[4]}</span></td>
                                <td><span className="column-label">{tableheadings[5]}</span>
                                    {calculateGroupSum(cat)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    </div>
                </div>
            </details>
            </Fragment>
        )
    }

    const getReportDetails = () => {
        if ( isReportReadonly() ) {
            return (
                <PomList
                    categories={categories}
                    reportData={reportData}
                    reportInfoData={reportTotSumData}
                    reportCatSumData={reportCatSumData}
                    period={period}
                    companyName={companyName}
                    summary={true}
                />
            )
        }
        else {
            return categories.map( (cat: IPomReportCategoryData, catIndex: number) => (
                getReportCategory(cat, catIndex)
            ))
        }
    }

    return (
        <>
        <Spinner active={loading} />
        <ToastWrap active={toastActive} heading={toastHeader} text={toastText} type={toastType} setActive={(active: boolean) => setToastActive(active)} />
        { !errorText &&
        <div id="reportinfo">
            <Form action="#" id="reportForm">

              <div className="action-buttons py-4 d-flex flex-row align-items-start">
                <div className="page-header">
                  {/* <h1><FormattedMessage id="report.header"/></h1> */}
                  <h1>{companyName} - {timePeriod}</h1>
                  <p className="info"><i className="fa fa-info-circle me-2"></i><FormattedMessage id="report.header.info"/></p>
                </div>

                <div className="ms-auto d-flex flex-row align-items-center">
                  <div className="ms-auto d-flex flex-row align-items-center state me-4 m-0">
                    {
                        statusView(editingReport ? REPORTSTATUS.EDITING : reportStatus, getDeadline(new Date(period)), (reportStatus === REPORTSTATUS.ONGOING) )
                    }
                  </div>
                  { getButtons() }
                </div>

              </div>


              <div className="highlight_bg">

                { confirmingPage && <div className="alert alert-warning" role="alert">
                  <div className="d-flex flex-row">
                    <i className="fa fa-info-circle me-2"></i>
                    <div>
                      <p className="error"><FormattedMessage id="report.header.confirm.text"/></p>
                      <button type="button" className="btn btn-primary btn-confirm my-4" onClick={() => confirmReport()}>
                        <i className="fa fa-check me-2"></i>
                        <FormattedMessage id="report.header.confirm"/>
                      </button>
                    </div>
                  </div>
                </div>}

                <p className="details-info">
                  <span className="key"><FormattedMessage id="report.header.reporter"/></span>
                  <span className="value">{reporter}</span>
                </p>

                <p className="details-info">
                  <span className="key"><FormattedMessage id="report.header.modified"/></span>
                  <span className="value senddate">{reportInfoData.modified && reportInfoData.modified.replace(/T|[.].+/g, " ")}</span>
                </p>

                <p className="details-info">
                  <span className="key"><FormattedMessage id="report.header.period"/></span>
                  <span className="value reportperiod">{timePeriod}</span>
                </p>

                {isReportReadonly() &&
                  <p className="details-info">
                    <span className="key"><FormattedMessage id="report.reference"/></span>
                    <span className="value">{reference}</span>
                  </p>
                }
                {!isReportReadonly() &&
                  <Form.Group className="form-group">
                    <Form.Label className="form-label">{intl.formatMessage({id: 'report.reference'})}</Form.Label>
                    <Form.Control onChange={handleReference} type="text" name="reporttype" className="form-control" value={reference}/>
                  </Form.Group>
                }

                {!isReportReadonly() &&
                  <>
                    <div className="alert alert-info">
                    <div className="d-flex flex-row">
                        <i className="fa fa-info-circle me-2"></i>
                        <div>
                        <p><FormattedMessage id="report.format.info"/></p>
                        </div>
                    </div>
                    </div>

                    <div className="controls d-flex justify-content-end my-3">
                    <button type="button" style={ !isAllOpen ? {} : {display: 'none'}}
                    onClick={() => {toggleDetailsSections("expand")}} className="btn btn-link expandall p-0">
                    <FormattedMessage id="report.details.open"/>
                        <i aria-hidden="true" className="fa fa-chevron-down ms-2"></i>
                    </button>
                    <button type="button" style={ isAllOpen ? {} : {display: 'none'}}
                    onClick={() => {toggleDetailsSections("close")}} className="btn btn-link closeall p-0">
                        <FormattedMessage id="report.details.close"/>
                        <i aria-hidden="true" className="fa fa-chevron-up ms-2"></i>
                    </button>
                    </div>
                  </>
                }

                { categories && categories.length > 0 &&
                    getReportDetails()
                }
              </div>
            </Form>
        </div>
        }
        { errorText &&
            <div id="reportinfo">
                {errorText}
            </div> }
        </>
    );
};